import { OpaqueToken } from "@angular/core";
export var HTTP_FACTORY = new OpaqueToken("Http implementation factory");
//# sourceMappingURL=http-factory.token.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-progress-http/lib/http-factory.token.js
// module id = ./node_modules/angular-progress-http/lib/http-factory.token.js
// module chunks = vendor